import RequestPageTwo from "./RequestPageTwo";

const KatinaRequests = () => {
    return (
        <RequestPageTwo title="Katina Ceremony"
            fetchUrl="/get-katina-ceremony-requests"
            editEndpoint="update-katina-ceremony-requests"
            deleteEndpoint="katina-ceremony-requests"
            statusEndpoint="katina-ceremony-requests" />
    );
}

export default KatinaRequests;
